import * as yup from 'yup';

const contactValidationSchema = (t) =>
  yup.object({
    contactFirstName: yup
      .string()
      .matches(/^([A-ZÁÉÚŐÓÜÖÍ]([A-ZÁÉÚŐÓÜÖÍa-záéúőóüöí -.]+\s?))$/, t('contactForm.validation.firstName.format'))
      .max(40, t('contactForm.validation.firstName.maxLength'))
      .required(t('contactForm.validation.firstName.required')),
    contactLastName: yup
      .string()
      .matches(/^([A-ZÁÉÚŐÓÜÖÍ]([A-ZÁÉÚŐÓÜÖÍa-záéúőóüöí -.]+\s?))$/, t('contactForm.validation.lastName.format'))
      .max(40, t('contactForm.validation.lastName.maxLength'))
      .required(t('contactForm.validation.lastName.required')),
    username: yup
      .string()
      .max(50, t('contactForm.validation.username.maxLength'))
      .required(t('contactForm.validation.username.required')),
    password: yup
      .string()
      .min(8, t('contactForm.validation.password.minLength'))
      .required(t('contactForm.validation.password.required')),
    passwordConfirm: yup
      .string()
      .required(t('contactForm.validation.passwordConfirm.required'))
      .when('password', (password) => {
        if (password) {
          return yup
            .string()
            .required(t('contactForm.validation.passwordConfirm.required'))
            .test(
              'do-the-password-match',
              t('contactForm.validation.passwordConfirm.match'),
              function (passwordConfirm) {
                return password === passwordConfirm;
              }
            );
        }
      }),
    contactEmail: yup
      .string()
      .email(t('contactForm.validation.email.format'))
      .required(t('contactForm.validation.email.required')),
    emailConfirm: yup
      .string()
      .email(t('contactForm.validation.emailConfirm.format'))
      .required(t('contactForm.validation.emailConfirm.required'))
      .when('contactEmail', (contactEmail) => {
        if (contactEmail) {
          return yup
            .string()
            .email(t('contactForm.validation.emailConfirm.format'))
            .required(t('contactForm.validation.emailConfirm.required'))
            .test('do-the-email-match', t('contactForm.validation.emailConfirm.match'), function (emailConfirm) {
              return contactEmail === emailConfirm;
            });
        }
      }),
    contactPhone: yup
      .string()
      .matches(/^[0-9]{8}|[0-9]{9}$/, t('contactForm.validation.phone.format'))
      .max(9, t('contactForm.validation.phone.maxLength'))
      .required(t('contactForm.validation.phone.required')),
    contactCountry: yup
      .string()
      .min(1, t('contactForm.validation.country.minLength'))
      .max(40, t('contactForm.validation.country.maxLength'))
      .required(t('contactForm.validation.country.required')),
    contactZipCode: yup
      .number()
      .typeError(t('contactForm.validation.zipCode.typeError'))
      .min(999, t('contactForm.validation.zipCode.min'))
      .max(9999, t('contactForm.validation.zipCode.max'))
      .required(t('contactForm.validation.zipCode.required')),
    contactCity: yup
      .string()
      .max(40, t('contactForm.validation.city.maxLength'))
      .required(t('contactForm.validation.city.required')),
    contactStreetAndNumber: yup
      .string()
      .min(1, t('contactForm.validation.streetAndNumber.minLength'))
      .max(40, t('contactForm.validation.streetAndNumber.maxLength'))
      .required(t('contactForm.validation.streetAndNumber.required'))
  });

export default contactValidationSchema;
